import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalSettingsStores from '../../../../../stores/settings-stores';

export const addBuildingToBranchOperations = async (
  branchId: number | undefined,
  buildingIds: number,
) => {
  try {
    if (!branchId) {
      toast.warn('לא ניתן לאתר את מזהה השלוחה, נסה שוב בעד מספר רגעים');
      return;
    }
    if (!buildingIds) {
      toast.warn('יש לבחור מבנה');
    }

    await appApi.addBuildingsToBranch(branchId, buildingIds);
    await globalSettingsStores.fetchSetting();
  } catch (e) {
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `addBuildingToBranchOperations is failed with the branchId: ${branchId}, buildingId: ${buildingIds} error: ${e}`,
    );
  }
};
